var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boolean-button__container",class:{ 'boolean-button__container--active': _vm.selected },on:{"click":_vm.changeValue}},[_c('v-icon',{staticClass:"boolean-button__button"},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }